<template lang="pug">
.disk
  section.disk-intro
    AppTitle.u-mb-sm(:title="$t('mantra')")

    p.u-text-lg.u-mb-sm {{$t('mantraDesc')}}
    .disk-intro-img
      img( src='https://cdn.baianat.com/static/resources/disk/1.jpg', srcset='https://cdn.baianat.com/static/resources/disk/1.jpg 1x, https://cdn.baianat.com/static/resources/disk/1@2x.jpg 2x')


  section.disk-features
    .grid.is-ultrawide-5.is-desktop-6.is-tablet-8
      .column
        h2.u-mb-xs {{$t('features')}}
        p {{$t('featuresDesc')}}
    .disk-features-img.u-mt-md
      img( src='https://cdn.baianat.com/static/resources/disk/2.jpg', srcset='https://cdn.baianat.com/static/resources/disk/2.jpg 1x, https://cdn.baianat.com/static/resources/disk/2@2x.jpg 2x')

  section.disk-stay.u-mt-lg
    .grid.is-widescreen-5.is-center
      .column
        .disk-stay-content
          img( src='/resources/disk/3.png', srcset='/resources/disk/3.png 1x, /resources/disk/3@2x.png 2x')
          h2 {{$t('organized')}}
          p.u-text-lg {{$t('organizedDesc')}}

  section.disk-folder.u-mt-lg
    AppTitle(:title="$t('folderCreation')" tag="h2")
    p {{$t('folderCreationDesc')}}


  section.disk-items.u-mt-lg
    h2.u-mb-mi {{$t('features')}}
    .grid.is-tablet-6
      .column.u-mb-sm
        .disk-items-card
          img( src='https://cdn.baianat.com/static/resources/disk/5.png', srcset='https://cdn.baianat.com/static/resources/disk/5.png 1x, https://cdn.baianat.com/static/resources/disk/5@2x.png 2x')
          div
            h4 {{$t('fullControl')}}
            p {{$t('fullControlDesc')}}
      .column.u-mb-sm
        .disk-items-card
          img( src='https://cdn.baianat.com/static/resources/disk/6.png', srcset='https://cdn.baianat.com/static/resources/disk/6.png 1x, https://cdn.baianat.com/static/resources/disk/6@2x.png 2x')
          div
            h4 {{$t('compression')}}
            p {{$t('compressionDesc')}}
      .column.u-mb-sm
        .disk-items-card
          img( src='https://cdn.baianat.com/static/resources/disk/7.png', srcset='https://cdn.baianat.com/static/resources/disk/7.png 1x, https://cdn.baianat.com/static/resources/disk/7@2x.png 2x')
          div
            h4 {{$t('fileViewer')}}
            p {{$t('fileViewerDesc')}}
      .column.u-mb-sm
        .disk-items-card
          img( src='https://cdn.baianat.com/static/resources/disk/8.png', srcset='https://cdn.baianat.com/static/resources/disk/8.png 1x, https://cdn.baianat.com/static/resources/disk/8@2x.png 2x')
          div
            h4 {{$t('powerfulSearch')}}
            p {{$t('powerfulSearchDesc')}}


  section.disk-cta.u-mt-md
    AppTitle.u-mb-0(:title="$t('cta')" tag="h3")





  .u-mb-md

</template>
<style lang="stylus">
$clMain = #2e3c48
$clBlue = #75d6f1

.app.is-disk
  overflow: hidden

  &.is-dark
    .header.is-scroll
      background: $clBlack

.disk
  &-intro
    padding-top: unitRes(200, 400)
    margin-left: -($outerMargin)
    margin-right: -($outerMargin)
    padding-right: $outerMargin
    padding-left: $outerMargin
    z-index: 0
    position: relative
    background-color: $clBlack
    background-repeat: no-repeat
    color: $clWhite
    z-index: 2

    +mq($until: 'tablet')
      margin-left: -($outerMargin-sm)
      margin-right: -($outerMargin-sm)
      padding-right: $outerMargin-sm
      padding-left: $outerMargin-sm

    p
      max-width: 800px

    &-img
      margin-left: -($outerMargin)
      margin-right: -($outerMargin)
      margin-top: unitRes(-100, -500)
      position: relative
      z-index: -1

      +mq($until: 'tablet')
        margin-left: -($outerMargin-sm)
        margin-right: -($outerMargin-sm)

      img
        width: 100%
        display: block
        margin-bottom: -1px

  &-features
    &-img
      position: relative
      z-index: 2

      img
        width: 100%

  &-stay
    &-content
      position: relative

      img
        position: absolute
        left: -120%
        top: 50%
        transform: translateY(-50%)

  &-folder
    position: relative
    z-index: 2
    margin-left: -($outerMargin)
    margin-right: -($outerMargin)
    background-color: $clBlack
    padding: unitRes(20, 160) $outerMargin
    color: $clWhite
    background-image: url('/resources/disk/4.png')
    background-repeat: no-repeat
    background-position: 100% center
    background-attachment: fixed
    text-shadow: 1px 1px 11px alpha($clBlack, 0.2)

    +mq($until: 'tablet')
      margin-left: -($outerMargin-sm)
      margin-right: -($outerMargin-sm)
      padding: unitRes(20, 160) $outerMargin-sm

    p
      max-width: 540px

  &-items
    &-card
      display: flex
      align-items: center

      img
        width: 120px
        flex: 0 0 120px
        margin-right: unitRes(20, 40)

        +mq($until: 'desktop')
          width: 80px
          flex: 0 0 80px

  &-cta
    background-color: $clBlue
    padding: unitRes(20, 160)
    color: $clBlack
    background-image: url('/resources/disk/9.png')
    background-repeat: no-repeat
    background-position: 100% center
    background-attachment: fixed
    text-shadow: 1px 1px 11px alpha($clWhite, 0.3)

html[lang^='ar']
  .disk
    &-cta, &-folder
      background-position: 0% center

    &-items-card img
      margin-right: 0
      margin-left: unitRes(20, 40)
</style>

<script>
import Prism from '~/components/Prism';
import { generateSeoMeta } from '~/utils/seo';

export default {
  scrollToTop: true,
  meta: {
    theme: 'is-disk is-fixedHeader is-whiteHeader',
    logoText: 'logoDiskTypo',
    logoIcon: 'logoDiskIcon'
  },
  head: generateSeoMeta(
    {
      title: 'pageTitle',
      description: 'pageDesc'
    },
    { i18n: true }
  ),
  components: {
    Prism
  },
  data: () => ({
    install: `npm install verte
# or use yarn
yarn add verte

# Usage

<template>
  <verte picker="square" model="rgb"><\/verte>
</template>

<script>
  import Verte from 'verte';
  import 'verte/dist/verte.css';
  // register component globally
  Vue.component(Verte.name, Verte);

  new Vue ({
    el: '#app',
    // OR register locally
    components: { Verte }
  });
<\/script>
`
  })
};
</script>

<i18n>
{
  "en": {
    "pageTitle":"Disk",
    "pageDesc":"Disk is Baianat file browser with image processing capabilities. It was developed it to help you organize your files and folders. ",
    "mantra":"One disk to| keep your files",
    "mantraDesc":"Disk is a file browser that lets you keep track of your documents in one place.",
    "demo":"Demo",
    "features":"Features",
    "featuresDesc":"Organize your files and folders using Disk and make sure your uploaded images are properly optimized using a built-in image optimization.",
    "organized":"Stay organized",
    "organizedDesc":"Choose between different sorting options and filter your files for better file management.",
    "folderCreation":"Folder |creation",
    "folderCreationDesc":"Create as many folders and directories as you like to properly nest your data according to your needs.",
    "fullControl":"Take full control",
    "fullControlDesc":"Upload, edit, move your files to have the structure you desire.",
    "compression":"Image compression",
    "compressionDesc":"Crop your images and resize them for further optimization of your media before you upload them to your severs.",
    "fileViewer":"File viewer",
    "fileViewerDesc":"Disk Comes with a file viewer that supports different formats for a quick file preview. All files can be download directly with one click.",
    "powerfulSearch":"Powerful Search",
    "powerfulSearchDesc":"Reach your files in an instance with an integrated search features to look through the different files and folders on Disk.",
    "cta":"Share and access files |everywhere, anytime.",
    "getStarted":"Get started"
  },
  "ar": {
    "pageTitle":"المكتب",
    "pageDesc":"المكتب هو ملف التصفح الخاص ببيانات مع قدرات لمعالجة الصور. تم تطويره خصيصًا لمساعدتك في تنظيم ملفاتك ومجلداتك وتحسين عملك.",
    "mantra":"مكتب واحد |لحفظ ملفاتك.",
    "mantraDesc":"المكتب هو متصفح ملفات يُمكنك من الاحتفاظ بملفاتك في مكان واحد.",
    "demo":"عرض",
    "features":"المميزات",
    "featuresDesc":"نظم ملفاتك ومجلداتك باستخدام المكتب وتأكد أن الصور التي قمت برفعها تم تحسينها باستخدام ملحق تحسين الصور.",
    "organized":"كُن أكثر تنظيمًا",
    "organizedDesc":"اكتشف خيارات التصنيف المختلفة وأفرز ملفاتك لتحصل على أفضل إدارة لها.",
    "folderCreation":"إنشاء |المجلدات",
    "folderCreationDesc":"قم بإنشاء العديد من المجلدات والمسارات بالشكل الذي تفضله، لتدخل بياناتك بالشكل الصحيح وفقًا لاحتياجاتك.",
    "fullControl":"تمتع بالسيطرة الكاملة",
    "fullControlDesc":"قم برفع وتعديل وتحريك ملفاتك ليكون لديك الهيكل الذي ترغب به.",
    "compression":"ضغط الصور",
    "compressionDesc":"يمكنك التحكم في صورك من حيث قصها أو تغيير حجمها لمزيد من التحسين لوسائطك قبل رفعها على خوادمك.",
    "fileViewer":"عارض للملفات",
    "fileViewerDesc":"المكتب يأتي مع عارض للملفات الذي يدعم بدوره تنسيقات مختلفة لمعاينة الملفات بسرعة. يمكنك تنزيل جميع الملفات مباشرة بنقرة واحدة.",
    "powerfulSearch":"بحث قوي",
    "powerfulSearchDesc":"قم بالوصول إلى ملفاتك باستخدام مميزات البحث المتكاملة للبحث في الملفات والمجلدات المختلفة الموجودة على المكتب.",
    "cta":"شارك وتحكم في ملفاتك |في أي وقت وأي مكان.",
    "getStarted":"ابدأ الآن!"
  }
}
</i18n>
